<template>
  <div class="profile-page">
    <Header />
    
    <!-- Hero Section -->
    <!-- <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1>My Profile</h1>
          <p>Manage your account, track orders, and view your EKU Tokens</p>
          <div class="breadcrumb">
            <router-link to="/">Home</router-link>
            <span class="separator">/</span>
            <span class="current">My Profile</span>
          </div>
        </div>
      </div>
    </section> -->

    <!-- Profile Content -->
    <section class="profile-section">
      <div class="container">
        <div class="profile-wrapper">
          
          <!-- Sidebar Navigation -->
          <aside class="profile-sidebar">
            <div class="user-avatar">
              <div class="avatar-image">
                <img src="https://via.placeholder.com/120" alt="User Avatar" v-if="false" />
                <div class="avatar-placeholder">
                  <i class="fas fa-user-circle"></i>
                </div>
              </div>
              <h3 class="user-name">{{ authStore.userDisplayName }}</h3>
              <p class="user-email">{{ authStore.user?.email || nill }}</p>
              <p class="user-phone">{{ authStore.user?.phone || nill }}</p>
              <div class="user-badge">
                <i class="fas fa-star"></i>
                <span>Premium Member</span>
              </div>
            </div>

            <nav class="sidebar-nav">
              <a href="#overview" @click.prevent="activeTab = 'overview'" :class="{ active: activeTab === 'overview' }">
                <i class="fas fa-tachometer-alt"></i>
                <span>Overview</span>
              </a>
              <a href="#profile" @click.prevent="activeTab = 'profile'" :class="{ active: activeTab === 'profile' }">
                <i class="fas fa-user-edit"></i>
                <span>Edit Profile</span>
              </a>
              <a href="#orders" @click.prevent="activeTab = 'orders'" :class="{ active: activeTab === 'orders' }">
                <i class="fas fa-shopping-bag"></i>
                <span>My Orders</span>
                <span class="badge">{{ authStore.ordercount }}</span>
              </a>
              <a href="#token" @click.prevent="activeTab = 'token'" :class="{ active: activeTab === 'token' }">
                <i class="fas fa-coins"></i>
                <span>EKU Tokens</span>
              </a>
              <a href="#addresses" @click.prevent="activeTab = 'addresses'" :class="{ active: activeTab === 'addresses' }">
                <i class="fas fa-map-marker-alt"></i>
                <span>Addresses</span>
              </a>
              <a href="#security" @click.prevent="activeTab = 'security'" :class="{ active: activeTab === 'security' }">
                <i class="fas fa-lock"></i>
                <span>Security</span>
              </a>
              <a href="#wishlist" @click.prevent="activeTab = 'wishlist'" :class="{ active: activeTab === 'wishlist' }">
                <i class="fas fa-heart"></i>
                <span>Wishlist</span>
              </a>
            </nav>
          </aside>

          <!-- Main Content Area -->
          <main class="profile-main">
            
            <!-- Overview Tab -->
            <div v-if="activeTab === 'overview'" class="tab-content">
              <!-- Stats Cards -->
              <div class="stats-grid">
                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="fas fa-shopping-cart"></i>
                  </div>
                  <div class="stat-info">
                    <h4>Total Orders</h4>
                    <p class="stat-number">{{authStore.ordercount}}</p>
                  </div>
                </div>
                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="fas fa-check-circle"></i>
                  </div>
                  <div class="stat-info">
                    <h4>Completed</h4>
                    <p class="stat-number">{{authStore.user?.completedorderCount?? 0}}</p>
                  </div>
                </div>
                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="fas fa-clock"></i>
                  </div>
                  <div class="stat-info">
                    <h4>Pending</h4>
                    <p class="stat-number">{{ authStore.user?.pendingorderCount?? 0 }}</p>
                  </div>
                </div>
                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="fas fa-eye"></i>
                  </div>
                  <div class="stat-info">
                    <h4>Watch-List</h4>
                    <p class="stat-number">{{ 23 }}</p>
                  </div>
                </div>
                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="fas fa-coins"></i>
                  </div>
                  <div class="stat-info">
                    <h4>EKU Tokens</h4>
                    <p class="stat-number token-value">{{ authStore.user?.ekutokecount?? 0 }}</p>
                  </div>
                </div>

                <div class="stat-card">
                  <div class="stat-icon">
                    <i class="fas fa-money-bill-wave"></i>
                  </div>
                  <div class="stat-info">
                    <h4>Balance</h4>
                    <p class="stat-number token-value">
                    TZS: {{ (authStore.user?.ekumarketTokenValue || 0) * (authStore.user?.ekutokecount || 0) | number_format }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Recent Orders -->
              <div class="recent-orders">
                <div class="section-header">
                  <h3>Recent Orders</h3>
                  <a href="#" @click.prevent="activeTab = 'orders'" class="view-all">View All</a>
                </div>
                <div class="orders-table-wrapper">
                  <table class="orders-table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Date</th>
                        <th>Items</th>
                        <th>Total</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td><span class="order-id">#EKU-12345</span></td>
                        <td>May 5, 2026</td>
                        <td>3 items</td>
                        <td>TZS 450,000</td>
                        <td><span class="status delivered">Delivered</span></td>
                        <td><a href="#" class="view-link">View</a></td>
                      </tr>
                      <tr>
                        <td><span class="order-id">#EKU-12344</span></td>
                        <td>April 28, 2026</td>
                        <td>1 item</td>
                        <td>TZS 89,000</td>
                        <td><span class="status shipped">Shipped</span></td>
                        <td><a href="#" class="view-link">View</a></td>
                      </tr>
                      <tr>
                        <td><span class="order-id">#EKU-12343</span></td>
                        <td>April 20, 2026</td>
                        <td>5 items</td>
                        <td>TZS 1,250,000</td>
                        <td><span class="status delivered">Delivered</span></td>
                        <td><a href="#" class="view-link">View</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <!-- EKU Token Summary -->
              <div class="token-summary">
                <div class="section-header">
                  <h3>EKU Token Summary</h3>
                  <a href="#" @click.prevent="activeTab = 'token'" class="view-all">View Details</a>
                </div>
                <div class="token-stats">
                  <div class="token-stat-item">
                    <span class="token-label">Current Balance</span>
                    <span class="token-amount">2,450 <span class="token-symbol">EKU</span></span>
                  </div>
                  <div class="token-stat-item">
                    <span class="token-label">Lifetime Earned</span>
                    <span class="token-amount">3,200 <span class="token-symbol">EKU</span></span>
                  </div>
                  <div class="token-stat-item">
                    <span class="token-label">Estimated Value</span>
                    <span class="token-amount">TZS 245,000</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- Edit Profile Tab -->
            <div v-if="activeTab === 'profile'" class="tab-content">
              <div class="edit-profile-form">
                <div class="section-header">
                  <h3>Edit Profile Information</h3>
                  <p>Update your personal information</p>
                </div>

                <form @submit.prevent="handleProfileUpdate" class="profile-form">
                  <div class="form-row">
                    <div class="form-group">
                      <label>Full Name</label>
                      <input type="text" v-model="profile.fullName" class="form-control" placeholder="Enter your full name" />
                    </div>
                    <div class="form-group">
                      <label>Email Address</label>
                      <input type="email" v-model="profile.email" class="form-control" placeholder="Enter your email" />
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <label>Phone Number</label>
                      <input type="tel" v-model="profile.phone" class="form-control" placeholder="Enter your phone number" />
                    </div>
                    <div class="form-group">
                      <label>Date of Birth</label>
                      <input type="date" v-model="profile.dob" class="form-control" />
                    </div>
                  </div>

                  <div class="form-group">
                    <label>Bio</label>
                    <textarea v-model="profile.bio" class="form-control" rows="4" placeholder="Tell us a little about yourself..."></textarea>
                  </div>

                  <div class="form-actions">
                    <button type="button" class="btn btn-secondary" @click="activeTab = 'overview'">Cancel</button>
                    <button type="submit" class="btn btn-primary">Save Changes</button>
                  </div>
                </form>
              </div>
            </div>

            <!-- My Orders Tab -->
            <div v-if="activeTab === 'orders'" class="tab-content">
              <div class="orders-full">
                <div class="section-header">
                  <h3>My Orders</h3>
                  <p>View all your order history</p>
                </div>

                <div class="filters">
                  <button class="filter-btn active">All Orders</button>
                  <button class="filter-btn">Pending</button>
                  <button class="filter-btn">Shipped</button>
                  <button class="filter-btn">Delivered</button>
                  <button class="filter-btn">Cancelled</button>
                </div>

                <div class="orders-table-wrapper">
                  <table class="orders-table full-table">
                    <thead>
                      <tr>
                        <th>Order ID</th>
                        <th>Date</th>
                        <th>Items</th>
                        <th>Total</th>
                        <th>Payment Method</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="order in allOrders" :key="order.id">
                        <td><span class="order-id">{{ order.id }}</span></td>
                        <td>{{ order.date }}</td>
                        <td>{{ order.items }} items</td>
                        <td>TZS {{ order.total.toLocaleString() }}</td>
                        <td>{{ order.paymentMethod }}</td>
                        <td><span :class="'status ' + order.status">{{ order.status }}</span></td>
                        <td><a href="#" class="view-link">View</a></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <!-- EKU Token Tab -->
            <div v-if="activeTab === 'token'" class="tab-content">
              <div class="token-details">
                <div class="section-header">
                  <h3>EKU Token Dashboard</h3>
                  <p>Track your tokens, earn rewards, and watch your value grow</p>
                </div>

                <div class="token-hero">
                  <div class="token-balance-card">
                    <div class="token-balance-icon">
                      <i class="fas fa-coins"></i>
                    </div>
                    <div class="token-balance-info">
                      <span class="token-label">Current Balance</span>
                      <span class="token-big-number">2,450</span>
                      <span class="token-subtext">EKU Tokens</span>
                    </div>
                  </div>
                  <div class="token-value-card">
                    <div class="token-value-info">
                      <span class="token-label">Estimated Value</span>
                      <span class="token-big-number">TZS 245,000</span>
                      <span class="token-subtext">1 EKU ≈ TZS 100</span>
                    </div>
                  </div>
                </div>

                <div class="token-stats-grid">
                  <div class="token-stat-box">
                    <i class="fas fa-chart-line"></i>
                    <h4>Lifetime Earned</h4>
                    <p class="stat-number">3,200 EKU</p>
                  </div>
                  <div class="token-stat-box">
                    <i class="fas fa-gift"></i>
                    <h4>From Purchases</h4>
                    <p class="stat-number">2,800 EKU</p>
                  </div>
                  <div class="token-stat-box">
                    <i class="fas fa-star"></i>
                    <h4>From Reviews</h4>
                    <p class="stat-number">250 EKU</p>
                  </div>
                  <div class="token-stat-box">
                    <i class="fas fa-users"></i>
                    <h4>From Referrals</h4>
                    <p class="stat-number">150 EKU</p>
                  </div>
                </div>

                <div class="token-transactions">
                  <h4>Recent Transactions</h4>
                  <div class="transactions-table-wrapper">
                    <table class="transactions-table">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Description</th>
                          <th>Amount</th>
                          <th>Type</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>May 5, 2026</td>
                          <td>Purchase at EKU Market (#EKU-12345)</td>
                          <td class="positive">+450 EKU</td>
                          <td>Earned</td>
                        </tr>
                        <tr>
                          <td>April 28, 2026</td>
                          <td>Product Review Bonus</td>
                          <td class="positive">+25 EKU</td>
                          <td>Earned</td>
                        </tr>
                        <tr>
                          <td>April 15, 2026</td>
                          <td>Referred Friend (John D.)</td>
                          <td class="positive">+50 EKU</td>
                          <td>Earned</td>
                        </tr>
                        <tr>
                          <td>March 30, 2026</td>
                          <td>Used for Discount</td>
                          <td class="negative">-200 EKU</td>
                          <td>Spent</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div class="token-actions">
                  <button class="btn btn-primary">Earn More Tokens</button>
                  <button class="btn btn-outline">Redeem Tokens</button>
                  <button class="btn btn-outline">View Token History</button>
                </div>
              </div>
            </div>

            <!-- Addresses Tab -->
            <div v-if="activeTab === 'addresses'" class="tab-content">
              <div class="addresses-section">
                <div class="section-header">
                  <h3>My Addresses</h3>
                  <button class="btn btn-primary btn-sm">Add New Address</button>
                </div>

                <div class="addresses-grid">
                  <div class="address-card">
                    <div class="address-header">
                      <i class="fas fa-home"></i>
                      <h4>Home Address</h4>
                      <span class="default-badge">Default</span>
                    </div>
                    <div class="address-content">
                      <p>John M. Customer</p>
                      <p>+255 745 450 431</p>
                      <p>123 Kinondoni Road</p>
                      <p>Dar es Salaam, Tanzania</p>
                    </div>
                    <div class="address-actions">
                      <button class="btn-icon"><i class="fas fa-edit"></i></button>
                      <button class="btn-icon"><i class="fas fa-trash"></i></button>
                    </div>
                  </div>

                  <div class="address-card">
                    <div class="address-header">
                      <i class="fas fa-briefcase"></i>
                      <h4>Work Address</h4>
                    </div>
                    <div class="address-content">
                      <p>John M. Customer</p>
                      <p>+255 745 450 431</p>
                      <p>456 Samora Avenue</p>
                      <p>Dar es Salaam, Tanzania</p>
                    </div>
                    <div class="address-actions">
                      <button class="btn-icon"><i class="fas fa-edit"></i></button>
                      <button class="btn-icon"><i class="fas fa-trash"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Security Tab -->
            <div v-if="activeTab === 'security'" class="tab-content">
              <div class="security-section">
                <div class="section-header">
                  <h3>Security Settings</h3>
                  <p>Manage your password and security preferences</p>
                </div>

                <div class="security-form">
                  <div class="form-group">
                    <label>Current Password</label>
                    <input type="password" class="form-control" placeholder="Enter current password" />
                  </div>
                  <div class="form-group">
                    <label>New Password</label>
                    <input type="password" class="form-control" placeholder="Enter new password" />
                  </div>
                  <div class="form-group">
                    <label>Confirm New Password</label>
                    <input type="password" class="form-control" placeholder="Confirm new password" />
                  </div>
                  <button class="btn btn-primary">Update Password</button>
                </div>

                <div class="security-settings">
                  <h4>Two-Factor Authentication</h4>
                  <p>Add an extra layer of security to your account</p>
                  <button class="btn btn-outline">Enable 2FA</button>
                </div>
              </div>
            </div>

            <!-- Wishlist Tab -->
            <div v-if="activeTab === 'wishlist'" class="tab-content">
              <div class="wishlist-section">
                <div class="section-header">
                  <h3>My Wishlist</h3>
                  <p>Products you've saved for later</p>
                </div>

                <div class="wishlist-grid">
                  <div class="wishlist-item">
                    <img src="https://via.placeholder.com/100" alt="Product" />
                    <div class="wishlist-info">
                      <h4>Apex Velocity S</h4>
                      <p class="price">TZS 45,000,000</p>
                      <button class="btn btn-sm btn-primary">Add to Cart</button>
                    </div>
                    <button class="remove-btn"><i class="fas fa-times"></i></button>
                  </div>
                  <div class="wishlist-item">
                    <img src="https://via.placeholder.com/100" alt="Product" />
                    <div class="wishlist-info">
                      <h4>Urbanite City Car</h4>
                      <p class="price">TZS 12,500,000</p>
                      <button class="btn btn-sm btn-primary">Add to Cart</button>
                    </div>
                    <button class="remove-btn"><i class="fas fa-times"></i></button>
                  </div>
                </div>
              </div>
            </div>

          </main>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { useAuthStore } from '@/Stores/authStore';

// Active tab state
const activeTab = ref('overview')
const authStore = useAuthStore();


// Profile data (hardcoded for now)
const profile = ref({
  fullName: 'John M. Customer',
  email: 'john.customer@example.com',
  phone: '+255 745 450 431',
  dob: '1990-05-15',
  bio: 'Tech enthusiast and car lover. Always looking for the best deals on EKU Market!'
})

// All orders data
const allOrders = ref([
  { id: '#EKU-12345', date: 'May 5, 2026', items: 3, total: 450000, paymentMethod: 'Mobile Money', status: 'delivered' },
  { id: '#EKU-12344', date: 'April 28, 2026', items: 1, total: 89000, paymentMethod: 'Credit Card', status: 'shipped' },
  { id: '#EKU-12343', date: 'April 20, 2026', items: 5, total: 1250000, paymentMethod: 'Bank Transfer', status: 'delivered' },
  { id: '#EKU-12342', date: 'April 10, 2026', items: 2, total: 234000, paymentMethod: 'Cash on Delivery', status: 'pending' },
  { id: '#EKU-12341', date: 'March 28, 2026', items: 1, total: 67000, paymentMethod: 'Mobile Money', status: 'cancelled' }
])

// Handle profile update (placeholder)
const handleProfileUpdate = () => {
  alert('Profile updated successfully! (Demo)')
  activeTab.value = 'overview'
}
</script>

<style scoped>
/* ============================================
   BASE STYLES
   ============================================ */
.profile-page {
  overflow-x: hidden;
  background: #f8f9fa;
  min-height: 100vh;
}

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 20px;
}

/* ============================================
   HERO SECTION
   ============================================ */
.hero-section {
  background: linear-gradient(135deg, #0a0a0a 0%, #1a1a1a 100%);
  padding: 60px 0 50px;
}

.hero-content h1 {
  font-size: 2.5rem;
  color: white;
  margin-bottom: 12px;
  font-weight: 700;
}

.hero-content p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
  margin-bottom: 16px;
}

.breadcrumb {
  display: flex;
  gap: 8px;
  font-size: 0.9rem;
}

.breadcrumb a {
  color: #D4AF37;
  text-decoration: none;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb .separator {
  color: rgba(255, 255, 255, 0.5);
}

.breadcrumb .current {
  color: rgba(255, 255, 255, 0.7);
}

/* ============================================
   PROFILE SECTION
   ============================================ */
.profile-section {
  padding: 60px 0 80px;
}

.profile-wrapper {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 30px;
}

/* ============================================
   SIDEBAR
   ============================================ */
.profile-sidebar {
  background: white;
  border-radius: 16px;
  padding: 30px 20px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 100px;
  height: fit-content;
}

.user-avatar {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
}

.avatar-placeholder {
  width: 100px;
  height: 100px;
  margin: 0 auto 15px;
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-placeholder i {
  font-size: 60px;
  color: white;
}

.user-name {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 5px;
  color: #1a1a1a;
}

.user-email, .user-phone {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 5px;
}

.user-badge {
  display: inline-block;
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
  margin-top: 10px;
}

.user-badge i {
  margin-right: 5px;
}

.sidebar-nav {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.sidebar-nav a {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 15px;
  border-radius: 10px;
  color: #555;
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
}

.sidebar-nav a i {
  width: 20px;
  font-size: 1.1rem;
}

.sidebar-nav a span {
  flex: 1;
}

.sidebar-nav a .badge {
  background: #ef4444;
  color: white;
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
}

.sidebar-nav a:hover {
  background: #f8f9fa;
  color: #D4AF37;
}

.sidebar-nav a.active {
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  color: white;
}

/* ============================================
   MAIN CONTENT
   ============================================ */
.profile-main {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
}

.tab-content {
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

.stat-card {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  gap: 15px;
  transition: all 0.3s ease;
}

.stat-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.stat-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.stat-icon i {
  font-size: 24px;
  color: white;
}

.stat-info h4 {
  font-size: 0.85rem;
  color: #666;
  margin-bottom: 5px;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: #1a1a1a;
}

.token-value {
  color: #D4AF37;
}

/* Section Header */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
}

.section-header h3 {
  font-size: 1.3rem;
  color: #1a1a1a;
}

.view-all {
  color: #D4AF37;
  text-decoration: none;
  font-size: 0.9rem;
}

.view-all:hover {
  text-decoration: underline;
}

/* Orders Table */
.orders-table-wrapper {
  overflow-x: auto;
}

.orders-table {
  width: 100%;
  border-collapse: collapse;
}

.orders-table th,
.orders-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.orders-table th {
  background: #f8f9fa;
  font-weight: 600;
  color: #555;
}

.order-id {
  font-weight: 600;
  color: #D4AF37;
}

.status {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 600;
}

.status.delivered {
  background: #d1fae5;
  color: #065f46;
}

.status.shipped {
  background: #e0f2fe;
  color: #0369a1;
}

.status.pending {
  background: #fed7aa;
  color: #9a3412;
}

.status.cancelled {
  background: #fee2e2;
  color: #991b1b;
}

.view-link {
  color: #D4AF37;
  text-decoration: none;
}

/* Token Summary */
.token-summary {
  margin-top: 30px;
  padding: 20px;
  background: linear-gradient(135deg, #fef9e3, #fff);
  border-radius: 12px;
  border: 1px solid rgba(212, 175, 55, 0.3);
}

.token-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 20px;
}

.token-stat-item {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.token-label {
  font-size: 0.85rem;
  color: #666;
}

.token-amount {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1a1a1a;
}

.token-symbol {
  font-size: 0.9rem;
  font-weight: normal;
  color: #666;
}

/* Edit Profile Form */
.profile-form {
  max-width: 800px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  font-weight: 500;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.form-control:focus {
  outline: none;
  border-color: #D4AF37;
  box-shadow: 0 0 0 3px rgba(212, 175, 55, 0.1);
}

textarea.form-control {
  resize: vertical;
}

.form-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
}

.btn {
  padding: 10px 24px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  border: none;
  font-size: 0.95rem;
}

.btn-primary {
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  color: #1a1a1a;
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(212, 175, 55, 0.3);
}

.btn-secondary {
  background: #f0f0f0;
  color: #666;
}

.btn-secondary:hover {
  background: #e0e0e0;
}

.btn-sm {
  padding: 6px 16px;
  font-size: 0.85rem;
}

.btn-outline {
  background: transparent;
  border: 2px solid #D4AF37;
  color: #D4AF37;
}

.btn-outline:hover {
  background: #D4AF37;
  color: white;
}

/* Filters */
.filters {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.filter-btn {
  padding: 8px 20px;
  background: #f0f0f0;
  border: none;
  border-radius: 20px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-btn.active {
  background: #D4AF37;
  color: white;
}

/* Token Tab */
.token-hero {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 30px;
}

.token-balance-card,
.token-value-card {
  background: linear-gradient(135deg, #0a0a0a, #1a1a1a);
  padding: 30px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.token-balance-icon {
  width: 70px;
  height: 70px;
  background: linear-gradient(135deg, #D4AF37, #FFD700);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.token-balance-icon i {
  font-size: 35px;
  color: #1a1a1a;
}

.token-balance-info,
.token-value-info {
  display: flex;
  flex-direction: column;
}

.token-label {
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
}

.token-big-number {
  font-size: 2rem;
  font-weight: 700;
  color: #D4AF37;
}

.token-subtext {
  color: rgba(255, 255, 255, 0.5);
  font-size: 0.8rem;
}

.token-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.token-stat-box {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  text-align: center;
}

.token-stat-box i {
  font-size: 30px;
  color: #D4AF37;
  margin-bottom: 10px;
}

.token-stat-box h4 {
  font-size: 0.9rem;
  color: #666;
  margin-bottom: 5px;
}

.token-stat-box .stat-number {
  font-size: 1.3rem;
  font-weight: 700;
  color: #1a1a1a;
}

.transactions-table {
  width: 100%;
  border-collapse: collapse;
}

.transactions-table th,
.transactions-table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #e0e0e0;
}

.positive {
  color: #10b981;
  font-weight: 600;
}

.negative {
  color: #ef4444;
  font-weight: 600;
}

.token-actions {
  display: flex;
  gap: 15px;
  margin-top: 30px;
  flex-wrap: wrap;
}

/* Addresses */
.addresses-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-top: 20px;
}

.address-card {
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 20px;
  position: relative;
  transition: all 0.3s ease;
}

.address-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.address-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e0e0e0;
}

.address-header i {
  color: #D4AF37;
  font-size: 1.2rem;
}

.address-header h4 {
  flex: 1;
}

.default-badge {
  background: #D4AF37;
  padding: 2px 10px;
  border-radius: 12px;
  font-size: 0.7rem;
  font-weight: 600;
}

.address-content p {
  margin-bottom: 5px;
  color: #666;
  font-size: 0.9rem;
}

.address-actions {
  margin-top: 15px;
  display: flex;
  gap: 10px;
}

.btn-icon {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  transition: color 0.3s ease;
}

.btn-icon:hover {
  color: #D4AF37;
}

/* Security */
.security-form {
  max-width: 500px;
  margin-bottom: 40px;
}

.security-settings {
  padding-top: 30px;
  border-top: 1px solid #e0e0e0;
}

.security-settings h4 {
  margin-bottom: 10px;
}

/* Wishlist */
.wishlist-grid {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.wishlist-item {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 20px;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  position: relative;
}

.wishlist-item img {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 8px;
}

.wishlist-info {
  flex: 1;
}

.wishlist-info h4 {
  margin-bottom: 8px;
}

.wishlist-info .price {
  color: #D4AF37;
  font-weight: 600;
  margin-bottom: 10px;
}

.remove-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #999;
  font-size: 1.2rem;
  transition: color 0.3s ease;
}

.remove-btn:hover {
  color: #ef4444;
}
/* ============================================
   RESPONSIVE
   ============================================ */

/* Tablet Landscape (1024px - 1366px) */
@media (max-width: 1024px) {
  .profile-wrapper {
    grid-template-columns: 250px 1fr;
    gap: 20px;
  }
  
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  /* Make tables scrollable on tablet too */
  .orders-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .orders-table {
    min-width: 700px;
  }
  
  .full-table {
    min-width: 800px;
  }
}

/* Tablet Portrait (768px - 1024px) */
@media (max-width: 768px) {
  .profile-wrapper {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .profile-sidebar {
    position: static;
    margin-bottom: 20px;
  }
  
  .profile-main {
    padding: 20px;
  }
  
  /* Form responsive */
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
  
  /* Token section responsive */
  .token-hero {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .stats-grid {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  /* Make ALL tables scrollable horizontally */
  .orders-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    margin: 0 -5px;
    padding: 0 5px;
  }
  
  .orders-table {
    width: 100%;
    min-width: 650px;
    font-size: 0.85rem;
  }
  
  .full-table {
    min-width: 750px;
  }
  
  .orders-table th,
  .orders-table td {
    padding: 10px 8px;
    white-space: nowrap;
  }
  
  /* Transactions table responsive */
  .transactions-table-wrapper {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  
  .transactions-table {
    min-width: 500px;
  }
  
  .transactions-table th,
  .transactions-table td {
    padding: 10px 8px;
    white-space: nowrap;
  }
  
  /* Wishlist responsive */
  .wishlist-item {
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  /* Address grid */
  .addresses-grid {
    grid-template-columns: 1fr;
  }
  
  /* Stats cards */
  .stat-card {
    padding: 15px;
  }
  
  .stat-number {
    font-size: 1.5rem;
  }
  
  /* Token stats */
  .token-stats-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
  
  .token-stat-box {
    padding: 15px;
  }
}

/* Mobile Large (480px - 768px) */
@media (max-width: 640px) {
  .container {
    padding: 0 15px;
  }
  
  .hero-content h1 {
    font-size: 1.8rem;
  }
  
  .profile-main {
    padding: 15px;
  }
  
  /* Make tables even more compact */
  .orders-table {
    min-width: 580px;
    font-size: 0.8rem;
  }
  
  .full-table {
    min-width: 680px;
  }
  
  .orders-table th,
  .orders-table td {
    padding: 8px 6px;
  }
  
  /* Token stats grid on small mobile */
  .token-stats-grid {
    grid-template-columns: 1fr;
  }
  
  /* Token actions */
  .token-actions {
    flex-direction: column;
    gap: 10px;
  }
  
  .token-actions .btn {
    width: 100%;
    text-align: center;
  }
  
  /* Stats cards */
  .stats-grid {
    gap: 12px;
  }
  
  .stat-card {
    padding: 12px;
  }
  
  .stat-icon {
    width: 40px;
    height: 40px;
  }
  
  .stat-icon i {
    font-size: 18px;
  }
  
  .stat-number {
    font-size: 1.3rem;
  }
  
  /* Token hero section */
  .token-balance-card,
  .token-value-card {
    padding: 20px;
  }
  
  .token-big-number {
    font-size: 1.5rem;
  }
  
  .token-balance-icon {
    width: 50px;
    height: 50px;
  }
  
  .token-balance-icon i {
    font-size: 24px;
  }
}

/* Mobile Small (up to 480px) */
@media (max-width: 480px) {
  .hero-content h1 {
    font-size: 1.5rem;
  }
  
  .container {
    padding: 0 12px;
  }
  
  .profile-main {
    padding: 12px;
  }
  
  /* Make tables scrollable with visible indicator */
  .orders-table-wrapper {
    position: relative;
    margin: 0 -12px;
    padding: 0 12px;
  }
  
  .orders-table-wrapper::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    width: 30px;
    background: linear-gradient(90deg, transparent, rgba(0,0,0,0.05));
    pointer-events: none;
    display: none; /* Optional: shows scroll hint */
  }
  
  .orders-table {
    min-width: 520px;
    font-size: 0.75rem;
  }
  
  .full-table {
    min-width: 620px;
  }
  
  .orders-table th,
  .orders-table td {
    padding: 6px 4px;
  }
  
  .order-id {
    font-size: 0.75rem;
  }
  
  .status {
    padding: 2px 8px;
    font-size: 0.7rem;
    white-space: nowrap;
  }
  
  /* Wishlist items */
  .wishlist-item {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }
  
  .wishlist-item img {
    width: 80px;
    height: 80px;
  }
  
  .wishlist-info h4 {
    font-size: 1rem;
  }
  
  /* Section headers */
  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .section-header h3 {
    font-size: 1.1rem;
  }
  
  /* Filters */
  .filters {
    gap: 8px;
  }
  
  .filter-btn {
    padding: 6px 12px;
    font-size: 0.8rem;
  }
  
  /* Address cards */
  .address-card {
    padding: 15px;
  }
  
  .address-header h4 {
    font-size: 1rem;
  }
  
  .address-content p {
    font-size: 0.8rem;
  }
  
  /* Token transactions */
  .transactions-table {
    min-width: 450px;
  }
  
  .transactions-table th,
  .transactions-table td {
    padding: 8px 6px;
    font-size: 0.75rem;
  }
  
  /* Token stats */
  .token-stat-box .stat-number {
    font-size: 1.1rem;
  }
  
  /* Buttons */
  .btn {
    padding: 8px 16px;
    font-size: 0.85rem;
  }
}

/* Ensure proper centering on all screens */
@media (max-width: 768px) {
  .profile-wrapper {
    display: flex;
    flex-direction: column;
  }
  
  .profile-sidebar {
    width: 100%;
  }
  
  .profile-main {
    width: 100%;
    overflow-x: hidden;
  }
  
  /* Ensure content doesn't overflow */
  .tab-content {
    overflow-x: hidden;
  }
  
  /* Center align text on mobile */
  .stat-card {
    text-align: center;
    justify-content: center;
  }
  
  .stat-card {
    flex-direction: column;
    text-align: center;
  }
  
  .stat-icon {
    margin: 0 auto 10px;
  }
  
  .token-stat-item {
    text-align: center;
  }
  
  .token-stats {
    justify-content: center;
  }
}
</style>